/* eslint-disable complexity */
import { PartnerIdConfigs } from '../../constants/login-dashboard.constants';
import {
  AccountCookie,
  DashboardResponse,
  LoginDashboardFieldsConfig
} from '../../models/login-dashboard.interfaces';

export const prepareLoginDashboardFieldsConfig = (
  accountCookieValue: AccountCookie | null,
  dashboardResponse: DashboardResponse | null,
  isHipmunk: boolean,
  isLogin: boolean,
  isBusinessUser: boolean
): LoginDashboardFieldsConfig | null => {
  if (
    isLogin &&
    isBusinessUser &&
    dashboardResponse &&
    accountCookieValue?.businessAccountOptionsList
  ) {
    const partnerIdConfig = isHipmunk
      ? PartnerIdConfigs['hipmunk']
      : PartnerIdConfigs[
          accountCookieValue.businessAccountOptionsList.partnerId
        ];

    const accountIndex =
      accountCookieValue.businessAccountOptionsList.accountIndex || 0;

    const canBookNonRefundable =
      dashboardResponse.canBookNonRefundable.split('|')[accountIndex];

    const bookOnlyRefundable = canBookNonRefundable !== 'false' ? false : true;

    return {
      disableMiles:
        partnerIdConfig?.disableMiles ||
        !!accountCookieValue.businessAccountOptionsList.disableMiles ||
        bookOnlyRefundable,
      restrictPaxToOne:
        partnerIdConfig?.restrictPaxToOne ||
        !!accountCookieValue.businessAccountOptionsList.restrictPaxToOne,
      bookOnlyRefundable,
      meetingEventDisclaimerType:
        partnerIdConfig?.displayInlineText ||
        accountCookieValue.businessAccountOptionsList.displayInlineText
    };
  }

  return null;
};
